import React, { Component } from 'react';
import './App.css';

import Map from './components/Map'
import MapDrawer from './components/DrawerComponent'
import DrawerToggler from './components/DrawerToggler';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import CssBaseline from '@material-ui/core/CssBaseline';

import Disclaimer from './components/Disclaimer'

import Cookies from 'universal-cookie';

import axios from 'axios'; 
import s from './settings';
import LayerSelector from './components/LayerSelector';

import utils from './utils';

import globals from './globals';

const apiServer = 'server';

var leafletMap = null;

axios.defaults.baseURL = s[apiServer].apiUrl

class App extends Component {
  codeList = [];
  ranljiveSkupine = [];

  constructor(props) {
    super(props);
    this.state = {
      layers:[],
      layerListItems:[],
      loading: false
    }
  }

  createMenuItems(layersData) {
    if (this.codeList['LAYERS']===undefined) return;
      //prevod drevesnega menija
      let layers = JSON.parse(this.codeList['LAYERS']['key_note']);

      layersData = layersData.reduce((accumulator, currentValue) => {
        const additional = JSON.parse(currentValue['additional']);
        const group = additional.key_group;
        if (additional.icon===undefined && currentValue.key_tbl_geom==='LINES') {
          additional.icon = 'polyline.svg';
        }
        currentValue.additional = additional;
        accumulator[currentValue.key_obj+"_"+group] = currentValue;
        return accumulator;
      }, {});

      let menuItems = [];

      let layersById = {};

      let inx = 1;

      let collapsables = [0];

      const fun = (obj, items, group) => {
        if (Array.isArray(obj)) {
          obj.map((x)=>fun(x, items, group));
        }
        else if (typeof obj === 'object') {
          for (let key in obj) {
            let g = {key: inx++, codeListKey: key, additional: {}, text: this.codeList[key].trans, items: []};
            items.push(g);
            collapsables.push(g.key);
            fun(obj[key], g.items, group===undefined ? key : group);
          };
        }
        else {
          const gkey = obj+"_"+group;

          if (layersData[gkey]) {
            const item = {key: inx++, record_count: layersData[gkey].record_count, additional: layersData[gkey].additional, codeListKey: obj, text: (this.codeList[obj] && (this.codeList[obj].trans || obj)) || obj, 
              layerId: layersData[gkey].id};

              layersById[item.layerId] = item;
            
            items.push(item)
          }
          else {
            console.log('missing key', gkey)
          }
        }
        
      }

      fun(layers, menuItems);

      this.setState({'layerListItems': menuItems,'collapsables': collapsables, 'layersById': layersById})
  }

  componentDidMount() {
    let self = this
    this.setState({loading: true});
    axios.post('/login', {
      email: s[apiServer].email,
      password: s[apiServer].password
    })
    .then(function (response) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.defaults.headers.get['Content-Type'] = 'application/json';
    })
    .then(function () {
      axios.all([axios.get('/code_list'),axios.get('/layers'), axios.get('/spatial/names')])
      .then(axios.spread((codeListResponse, layersResponse, spatialNames) => {
        
        globals.spatialNames = spatialNames.data;
          
        self.codeList = codeListResponse.data.data.reduce((accumulator, currentValue) => {
          if (currentValue.trans) {
            currentValue.trans = utils.hstore2object(currentValue.trans);
            if (currentValue.trans) {
              currentValue.trans = currentValue.trans.sl;
            }
            else {
              currentValue.trans = currentValue.key
            }
          }
          else {
            currentValue.trans = currentValue.key
          }
          
          accumulator[currentValue.key] = currentValue;
          return accumulator;
        }, {});

        self.createMenuItems(layersResponse.data.data);

        self.setState({
          layers: layersResponse.data.data
        });
      }))
    }) 
    .catch(function (error) {
      console.log(error);
    }).then(() => //always executed
    this.setState({loading: false})
  );
  }

  setMapReference(_map) {
    leafletMap = _map;
  }

  checkDisclaimerCookie() {
    const cookies = new Cookies();
    return cookies.get('disclaimer') !== 'confirmed';
  }

  render() {
    return (
      <div className="App">
        {this.checkDisclaimerCookie() && <Disclaimer/>}
        <CssBaseline></CssBaseline>      
        <MapDrawer
          drawerContent={[<LayerSelector 
            layersById = {this.state.layersById}
            loading = {this.state.loading}
            leafletMap = {leafletMap} key="layer-selector" ranljiveSkupine={this.ranljiveSkupine} codeList={this.codeList} layers={this.state.layers}
          layerListItems = {this.state.layerListItems} collapsables = {this.state.collapsables}
          ></LayerSelector>]}
        >
          <Map setReference={this.setMapReference}>
            <DrawerToggler>
              <MoreHorizIcon></MoreHorizIcon>
            </DrawerToggler>
          </Map>
        </MapDrawer>
      </div>
    );
  }
}

export default App;
